// extracted by mini-css-extract-plugin
module.exports = {"field":"TimeOffDetailsModal_field__1MaSW","attachments":"TimeOffDetailsModal_attachments__2NRoA"};